var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
// import AvatarComponent from "react-avatar";
import { createAvatarComponent, ValueSource, SrcSource } from "react-avatar";
import PropTypes from "prop-types";
import "./Avatar.scss";
var AvatarComponent = createAvatarComponent({
  sources: [ValueSource, SrcSource]
});
var sizes = {
  "xs": "1.5rem",
  "sm": "2.25rem",
  "md": "3rem",
  "lg": "3.625rem"

};

var textRatio = {
  "xs": 0.542,
  "sm": 0.472,
  "md": 0.542,
  "lg": 0.35
};

var fontSizes = {
  "xs": "0.813rem",
  "sm": "1.063rem",
  "md": "1.188rem",
  "lg": "1.1625rem"
};
var Avatar = function Avatar(_ref) {
  var size = _ref.size,
      textSizeRatio = _ref.textSizeRatio,
      props = _objectWithoutProperties(_ref, ["size", "textSizeRatio"]);

  return React.createElement(AvatarComponent, _extends({ size: sizes[size] || size, className: "avatar avatar-" + size, style: { fontSize: fontSizes[size] || "1rem" } }, props));
};
Avatar.defaultProps = {
  round: true,
  size: "sm",
  maxInitials: 2
};

Avatar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * User name
   */
  name: PropTypes.string,
  /**
   * size of the avatar
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["xs", "sm", "md", "lg"]), PropTypes.string]),
  /**
   * background color (forcefully set)
   */
  color: PropTypes.string,
  /**
   * range of colors
   */
  colors: PropTypes.array,
  /**
   * profile image url
   */
  src: PropTypes.string,

  /**
   * rounded
   */
  round: PropTypes.bool,

  /**
   * maxInitials: Set max nr of characters used for the initials. If maxInitials=2 and the name is Foo Bar Var the initials will be FB
   */
  maxInitials: PropTypes.number
} : {};
export default Avatar;